// extracted by mini-css-extract-plugin
export var cImageText = "ImageText-module--c-image-text--16ad4";
export var cImageText__image = "ImageText-module--c-image-text__image--ff8b0";
export var cImageText__reverse = "ImageText-module--c-image-text__reverse--8c041";
export var cImageText__text = "ImageText-module--c-image-text__text--0e115";
export var cImageText__textreverse = "ImageText-module--c-image-text__textreverse--f4396";